/* eslint-disable import/no-duplicates */
import classnames from "classnames";
import FooterNavigationList from "components/molecules/FooterNavigationList";
import FooterPartnersList from "components/molecules/FooterPartnersList";
import FooterPaymentsList from "components/molecules/FooterPaymentsList";
import FooterSocialList from "components/molecules/FooterSocialList";
import SkeletonFooter from "components/molecules/SkeletonFooter";
import SkeletonFooterMobile from "components/molecules/SkeletonFooterMobile";
import { FOOTER_CASINO as casino } from "constants/navigation";
import { FOOTER_INFORMATION as information } from "constants/navigation";
import useTranslate from "hooks/useTranslate";
import { useLoaderStore } from "stores/loader";
import { useBreakpoint } from "hooks/useBreakpoint";
import GloryLogotype from "assets/icons/glory/logo_big.svg?react";
import BangerLogotype from "assets/icons/banger/logo.svg?react";

import "./styles.sass";
import LanguageSelectContainer from "containers/molecules/LanguageSelectContainer";

const Footer = () => {
  const { VITE_APP_PROJECT_NAME } = import.meta.env;
  const { overlayLoading } = useLoaderStore();
  const t = useTranslate();

  const { isDesktop } = useBreakpoint();

  if (overlayLoading) {
    return isDesktop ? <SkeletonFooter /> : <SkeletonFooterMobile />;
  }

  const FooterLogoClass = classnames("Footer__navigation__logo", {
    // eslint-disable-next-line camelcase
    Footer__navigation__logo_glory: VITE_APP_PROJECT_NAME === "glory",
  });
  return (
    <div className="Footer">
      <div className="Footer-wrapper">
        <div className="Footer__navigation">
          <div className={FooterLogoClass}>
            {VITE_APP_PROJECT_NAME === "glory" ? (
              <GloryLogotype />
            ) : (
              <BangerLogotype />
            )}
          </div>
          <FooterNavigationList title="footer.casino" list={casino} />
          <FooterNavigationList title="footer.information" list={information} />
          <div className="Footer__container">
            <FooterSocialList />
            {isDesktop && <LanguageSelectContainer />}
          </div>
        </div>
        <div className="Footer__navigation_tablet">
          <div className={FooterLogoClass}>
            {VITE_APP_PROJECT_NAME === "glory" ? (
              <GloryLogotype />
            ) : (
              <BangerLogotype />
            )}
          </div>
          <div className="Footer__navigation_tablet_menu">
            <FooterNavigationList title="footer.casino" list={casino} />
            <FooterNavigationList
              title="footer.information"
              list={information}
            />
          </div>
        </div>
        <hr className="Footer__payments_hr" />
        <div className="Footer__payments">
          <FooterPaymentsList />
        </div>
        <hr className="Footer__payments_hr" />
        <div className="Footer__partners">
          <FooterPartnersList />
        </div>
        <div className="Footer__license">
          {t(`footer.license.${VITE_APP_PROJECT_NAME}`)}
        </div>
        {/* {VITE_APP_PROJECT_NAME === "banger" && (
          <noindex>
            <div className="Footer__license">{t("error.footer")}</div>
          </noindex>
        )} */}
        {import.meta.env.VITE_APP_VERSION_APP && (
          <div className="Footer__version">
            Version {import.meta.env.VITE_APP_VERSION_APP}
          </div>
        )}
      </div>
    </div>
  );
};

export default Footer;
